"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _createFirebaseInstance = _interopRequireDefault(require("./createFirebaseInstance")),
    _ReactReduxFirebaseProvider = _interopRequireDefault(require("./ReactReduxFirebaseProvider")),
    _ReactReduxFirebaseContext = _interopRequireDefault(require("./ReactReduxFirebaseContext")),
    _ReduxFirestoreProvider = _interopRequireDefault(require("./ReduxFirestoreProvider")),
    _ReduxFirestoreContext = _interopRequireDefault(require("./ReduxFirestoreContext")),
    _firebaseConnect = _interopRequireWildcard(require("./firebaseConnect")),
    _firestoreConnect = _interopRequireWildcard(require("./firestoreConnect")),
    _withFirebase = _interopRequireWildcard(require("./withFirebase")),
    _withFirestore = _interopRequireWildcard(require("./withFirestore")),
    _useFirebaseConnect = _interopRequireWildcard(require("./useFirebaseConnect")),
    _useFirestoreConnect = _interopRequireWildcard(require("./useFirestoreConnect")),
    _useFirebase = _interopRequireWildcard(require("./useFirebase")),
    _useFirestore = _interopRequireWildcard(require("./useFirestore")),
    _reducer = _interopRequireDefault(require("./reducer")),
    _constants = _interopRequireWildcard(require("./constants")),
    _auth = require("./utils/auth"),
    helpers = _interopRequireWildcard(require("./helpers"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) return obj;
  var newObj = {};
  if (null != obj) for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
      desc.get || desc.set ? Object.defineProperty(newObj, key, desc) : newObj[key] = obj[key];
    }
  }
  return newObj.default = obj, newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null == arguments[i] ? {} : arguments[i],
        ownKeys = Object.keys(source);
    "function" == typeof Object.getOwnPropertySymbols && (ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
      return Object.getOwnPropertyDescriptor(source, sym).enumerable;
    }))), ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, {
    value: value,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : obj[key] = value, obj;
}

var _default = _objectSpread({
  ReactReduxFirebaseProvider: _ReactReduxFirebaseProvider.default,
  ReactReduxFirebaseConsumer: _ReactReduxFirebaseContext.default.Consumer,
  ReactReduxFirebaseContext: _ReactReduxFirebaseContext.default,
  ReduxFirestoreContext: _ReduxFirestoreContext.default,
  ReduxFirestoreProvider: _ReduxFirestoreProvider.default,
  ReduxFirestoreConsumer: _ReduxFirestoreContext.default.Consumer,
  createFirebaseInstance: _createFirebaseInstance.default,
  firebaseConnect: _firebaseConnect.default,
  createFirebaseConnect: _firebaseConnect.createFirebaseConnect,
  firestoreConnect: _firestoreConnect.default,
  createFirestoreConnect: _firestoreConnect.createFirestoreConnect,
  withFirebase: _withFirebase.default,
  createWithFirebase: _withFirebase.createWithFirebase,
  withFirestore: _withFirestore.default,
  createWithFirestore: _withFirestore.createWithFirestore,
  useFirebase: _useFirebase.default,
  createUseFirebase: _useFirebase.createUseFirebase,
  useFirebaseConnect: _useFirebaseConnect.default,
  createUseFirebaseConnect: _useFirebaseConnect.createUseFirebaseConnect,
  useFirestore: _useFirestore.default,
  createUseFirestore: _useFirestore.createUseFirestore,
  useFirestoreConnect: _useFirestoreConnect.default,
  createUseFirestoreConnect: _useFirestoreConnect.createUseFirestoreConnect,
  reducer: _reducer.default,
  firebaseReducer: _reducer.default,
  firebaseStateReducer: _reducer.default,
  constants: _constants.default,
  actionTypes: _constants.actionTypes,
  authIsReady: _auth.authIsReady,
  helpers: helpers
}, helpers);

exports.default = _default, module.exports = exports.default;